// src/pages/AuthPage.js
import { useNavigate, useLocation } from "react-router-dom";
import LoginForm from "../../../components/LoginForm";
import SignupForm from "../../../components/SignupForm";
import logo from "../../../image/LogoNavvayu.png";
import "./AuthPage.css";

const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on URL
  const activeTab = location.pathname === "/signup" ? "signup" : "login";

  // Handle tab switch
  const handleTabSwitch = (tab) => {
    navigate(tab === "login" ? "/login" : "/signup");
  };

  return (
    <div className="auth-container d-flex justify-content-center align-items-center">
      <div className="card auth-card shadow" style={{ maxWidth: 550, width: "100%" }}>
        <div className="card-body">
          <img src={logo} alt="Logo" className="auth-logo mb-4" style={{ width: "100%" }} />
          {/* Tabs */}
          <ul className="nav nav-pills nav-justified mb-4 d-flex p-1">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "login" ? "active" : ""}`}
                onClick={() => handleTabSwitch("login")}
              >
                Login
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "signup" ? "active" : ""}`}
                onClick={() => handleTabSwitch("signup")}
              >
                Sign Up
              </button>
            </li>
          </ul>

          {activeTab === "login" && <LoginForm />}
          {activeTab === "signup" && <SignupForm />}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
